import { Typography, styled } from "@mui/material";

export const TableHeader = styled(Typography)({
    color: '#2a2a2a',
    fontSize: '13px',
    fontVariant: 'body2',
    fontWeight: "500"
});